(function() {
function apilayer(tbox,pbuilder,sockio,sioc,oo) {
 if(!oo) oo = {};

 var L;
 if(oo.L) L = oo.L;
 else {
  L = ['trace','debug','info','warn','error','fatal'].reduce(function(p,c) {
   p[c] = function(d,m) {
    if(m) console.log(c+': '+m,d);      // eslint-disable-line no-console
    else console.log(c+': '+d);         // eslint-disable-line no-console
   };
   return p;
  },{});
 }

 // Return true if things look as if we're using named, not positional parameters.
 function isparbundle(p1,p2) {
  return ('object'==typeof p1) && !(p1 instanceof Array) && ('undefined'==typeof p2);
 }
 // takes either bytes array or number and returns array of bytes
 function any2bytes(x) {
  if(x===undefined || x===null) return x;
  return (x instanceof Array)?x:tb.number2Bytes(+x);
 }
 // create a nice new packetbuilder nicely setup
 // <type> | {type:,connid:}
 function newp(p) {
  var t = p.type||p;
  var cid = p.connid||0;
  var rv = new PB(TB);
  rv.setHeader(getAckNumber(0),getSeqNumber(0),cid,t);
  rv.send = function send_pdu() {
   return sendpdu(this),this;
  };
  return rv;
 }

 var that = this;
 var sio = oo.sio||(sockio?new sockio(sioc,{L:L}):new socketio());
 var TB = tbox||toolbox;
 var PB = pbuilder||packetbuilder;
 var tb = new TB();
 var _callback = null;
 var sequenceNumber = new Array();
 var ackNumber = new Array();
 var accountid;
 var sessionid;
 var token;
 var _permissions = new Array();
 var _groups = new Array();
 var _conversations = new Array();
 var _permission_info = {};
 var _fileSize;
 var _fileData = new Array();
 var _domain;
 var _productid;
 // Initializes the api by calling socket io init
 this.init = function apilayer_init(hosturl,port,cb,pp) {
  _callback = cb;
  if(typeof(pp)=='object') {
   _domain = pp.d;
   _productid=pp.pid;
  }
  else _domain = pp;
  sio.init(hosturl, port, callback);
  return this;
 };
 this.set_logger = function(l) {
  L=l;
  if(sio && sio.set_logger) sio.set_logger(l);
  return this;
 };
 this.shutdown = function apilayer_shutdown() {
  if(sio.shutdown) sio.shutdown();
  return this;
 };
 this.on = function apilayer_on(evt,cb) {
  _callback[evt]=cb;
  return this;
 };
 
 // Creates a user account
 this.createAccount = function(username,password,email,phone){
  L.trace("createAccount");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,10).
  addByte(username.length).
  addString(username).
  addByte(password.length).
  addString(password);
  function add(t,v) {
   if(!v) return;
   pb.addBytes(t).
   addByte(v.length).
   addString(v);
  }
  add(2,email);
  add(3,phone);
  /* TODO: the above is somewhat ugly, but the hardcoded below is worse than ugly */
  pb.addByte(1).
  addByte(0).
  addByte(255).
  addByte(2).
  addInt16(3).
  addByte(0);
  sendpdu(pb);
 };
 
 // Attempts login using user account
 // bundle: { actype:,acname:,password }
 this.attemptLogin = function(username, password, type) {
  L.trace("attemptLogin");
  if(isparbundle(username,password)) {
   type = username.actype;
   password = username.password;
   username = username.acname||username.username||username.email||username.mobile;
  }
  newp(2).addByte(type)
   .addByte(username.length).addString(username)
   .addString(password)
   .send();
 };
 
 // Gets LANID
 this.getLANID = function(num,reqID) {
  L.trace("getLANID");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,1280);
  if(num != ""){
   pb.addInt16(256).
   addInt16(1).
   addByte(num);
  }
  if(reqID != ""){
   pb.addInt16(257).
   addInt16(1).
   addByte(reqID);
  }
  sendpdu(pb);
 };
 
 // Resolves LANID
 this.resolveLANID = function(lid) {
  L.trace("resolveLANID");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,1282).
  addInt16(258).
  addInt16(lid.length).
  addString(lid);
  sendpdu(pb);
 };
 
 // Looks up for an account id by its name
 this.lookupAccount = function(acctype,accName) {
  L.trace("lookupAccount");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,64).
  addByte(acctype).
  addString(accName);
  sendpdu(pb);
 };
 
 // Gets all permissions with a particular permission code - #128
 this.getPermissions = function(permissionCode, acid, direction) {
  L.trace("getPermissions");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,128).
  addInt16(256).
  addInt16(4).
  addInt32(permissionCode).
  addInt16(257).
  addInt16(1).
  addByte(1);
  if(acid) {
   pb.addInt16(1).
   addInt16(acid.length).
   addBytes(acid);
  }
  if(direction) {
   pb.addInt16(259).
   addInt16(1).
   addByte(direction);
  }
  sendpdu(pb);
 };
 
 // Grants permission to a client - #144
 this.grantRequestPermissionToAClient = function(taccID,grants,requests,userdata) {
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,144).
  addInt16(259).
  addInt16(taccID.length).
  addBytes(taccID);
  if(grants) {
   pb.addInt16(262).
   addInt16(grants.length*(4+2));
   for(var ig=0; ig<grants.length; ig++)
    pb.addInt16(4).addInt32(grants[ig]);
  }
  if(requests) {
   pb.addInt16(263).
   addInt16(requests.length*(4+2));
   for(var ir=0; ir<requests.length; ir++)
    pb.addInt16(4).addInt32(requests[ir]);
  }
  if(userdata) {
   pb.addInt16(128).
   addInt16(taccID.length+4).
   addBytes(taccID).
   addInt32(userdata);
  }
  if(grants || requests) sendpdu(pb);
 };
 
 // Accepts permission to a client - #146
 this.allowPermission = function(permissionID, allow) {
  var pb = new PB(TB);
  L.trace("allowpermission");
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,146).
  addInt16(264).
  addInt16(permissionID.length).
  addBytes(permissionID).
  addInt16(265).
  addInt16(1).
  addByte(allow);
  sendpdu(pb);
 };
 
 // Registers a device
 // bundle: {name:[,type:][,model:][,imei:][,display_name:][,productid:]}
 this.registerADevice = function(deviceName,deviceType,deviceModel,imei,displayName,productId) {
  L.trace("registerADevice");
  if(isparbundle(deviceName,deviceType)) {
   productId = deviceName.productid;
   displayName = deviceName.display_name;
   imei = deviceName.imei;
   deviceModel = deviceName.model;
   deviceType = deviceName.type;
   deviceName = deviceName.name;
  }
  var pb = newp(40).addItem({tag:256,string:deviceName});
  if(deviceType) pb.addItem({tag:260,int8:deviceType});
  if(deviceModel) pb.addItem({tag:259,string:deviceModel});
  if(imei) pb.addItem({tag:261,string:imei});
  if(displayName) pb.addItem({tag:262,string:deviceName});
  if(productId) pb.addItem({tag:400,bytes:productId});
  pb.send();
 };
 
 // Attempts login using device token
 // bundle: {devid:,token:}
 this.attemptTokenLogin = function(deviceID,token) {
  L.trace("attemptTokenLogin");
  if(isparbundle(deviceID,token)) {
   token = deviceID.token;
   deviceID = any2bytes(deviceID.devid);
  }
  newp(25).addBytes(deviceID).addBytes(token).send();
 };
 
 // Creates conversation
 // { [acid:,] channelid:[, msg:, devid:, convType:, convid:] }
 this.createConversation = function(p) {
  L.trace({p:p},"createConversation");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,384);
  var acid = any2bytes(p.acid||p.accountID);
  if(acid) pb.addItem({tag:1,bytes:acid});
  pb.addItem({tag:260,int32:p.channelid||p.channelID});
  if(p.msg) pb.addItem({tag:261,string:p.msg});
  var did = any2bytes(p.devid||p.deviceID);
  if(did) pb.addItem({tag:4,bytes:did});
  if(p.convType) pb.addItem({tag:270,int8:p.convType});
  var convid = any2bytes(p.convid);
  if(convid) pb.addItem({tag:256,bytes:convid});
  sendpdu(pb);
 };

 // Add user to the conversation
 // { convid:,acid: }
 this.addUserToTheConversation = function(p) {
  L.trace({p:p},"add user to the conversation");
  newp(398).addItem({tag:256,number:p.convid})
           .addItem({tag:1,number:p.acid})
           .send();
 };

 // Remove user from the conversation
 // { convid:,acid: }
 this.removeUserFromTheConversation = function(p) {
  newp(399).addItem({tag:256,number:p.convid})
           .addItem({tag:1,number:p.acid})
           .send();
 };
 
 // Invites a user to a conversation
 this.inviteUser = function(convID,accID) {
  L.trace("inviteUser");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,258).
  addInt16(256).
  addInt16(convID.length).
  addBytes(convID).
  addInt16(1).
  addInt16(accID.length).
  addBytes(accID);
  sendpdu(pb);
 };
 
 // Accepts the invitation from a user to a conversation
 this.allowInvitation = function(convID,allow){
  L.trace("allowInvitation");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,260).
  addInt16(256).
  addInt16(convID.length).
  addBytes(convID).       
  addInt16(259).
  addInt16(1).
  addByte(allow);
  sendpdu(pb);
 };
 
 // Sends message
 // bundle: { convid:, channelid:, msg:, devid:, validity: }
 this.sendMessage = function(conversationID,channelID,msg,deviceID,validity) {
  var pars;
  if(isparbundle(conversationID,channelID)) {
   pars = conversationID;
   conversationID = any2bytes(pars.convid);
   channelID = pars.channelid|pars.channel;
   msg = pars.msg;
   deviceID = any2bytes(pars.devid);
   validity = pars.validity;
  }
  conversationID || L.warn("trying to send message to no conversation");
  channelID || L.warn("trying to send message to no channel");
  msg || L.warn("trying to send no message");
  L.trace({cid:conversationID,m:msg,len:msg.length,chid:channelID,devid:deviceID},"sending message to the conversation");
  var pb = newp(386);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,386)
   .addItem({tag:256,bytes:conversationID})
   .addItem({tag:260,int32:channelID})
   .addItem({tag:261,string:msg});
  if(deviceID) pb.addItem({tag:4,bytes:deviceID});
  if(validity) pb.addItem({tag:272,int32:validity});
  pb.send();
  return this;
 };

 // Sends PDU
 function sendpdu(pb_) {
  var bytes = pb_.getBytes(true);
  /*
  var pb = new PB(TB);
  var ps = pb.addBytes(bytes).extractpacket();
  //L.trace({bytes:bytes,ps:ps},"pdu sent");
  */
  sequenceNumber[0]++;
  sio.send(bytes);
 }
 // Sends greeting
 function sendGreeting(domain,pid) {
  L.trace({domain:domain},"sendGreeting to domain " + domain);
  sequenceNumber[0] = 1;
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,1).
  addInt16(256).
  addInt16(4).
  addInt32(domain||0);
  if(pid) {
   pb.addInt16(400).
   addInt16(pid.length).
   addBytes(pid);
  }
  sendpdu(pb);
 }
 
 // Gets acknowledgement number
 function getAckNumber(connID) {
  return ackNumber[connID];
 }
 
 // Gets sequence number
 function getSeqNumber(connID) {
  return sequenceNumber[connID];
 }
 
 //Query list of pending permissions
 this.getPendingPermissionList = function() {
  L.trace("getPendingPermissionList");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,147);
  sendpdu(pb);
 };
 
 // Query list of conversations - #390
 this.getListofAllConversations = function() {        
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,390);
  sendpdu(pb);
 };
 
 // Query list of members in conversation - #392
 this.getListOfConversationMembers = function(conversationID) {
  conversationID = any2bytes(conversationID);
  var pb = new PB(TB);      
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,392). 
  addInt16(256).
  addInt16(conversationID.length).
  addBytes(conversationID);
  sendpdu(pb);
 };
 
 // Leave conversation - #394
 this.leaveConversation = function(conversationID) {
  var pb = new PB(TB);      
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,394). 
  addInt16(256).
  addInt16(conversationID.length).
  addBytes(conversationID);
  sendpdu(pb);
 };
 
 //confirm message delivery
 this.confirmMessageDelivery = function(msgiD) {
  var pb = new PB(TB);      
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,388).
  addInt16(263).
  addInt16(msgiD.length).
  addBytes(msgiD);
  sendpdu(pb);
 };
 
 // Create Virtual Connection - #896
 // bundle: { acid:, devid:, sid:, pcode: }
 this.createVirtualConnection = function(taccountID, deviceID, sessionID, permissioncode) {
  if(isparbundle(taccountID,deviceID)) {
   var pars = taccountID;
   taccountID = any2bytes(pars.acid);
   deviceID = any2bytes(pars.devid);
   sessionID = pars.sid||""; // TODO: I have no idea if it makes sense
   permissioncode = pars.pcode;
  }
  var pb = new PB(TB);
  L.trace("createVirtualConnection"); 
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,896). 
  addInt16(1).
  addInt16(taccountID.length).
  addBytes(taccountID);
  if(deviceID) {
   pb.addInt16(4).
   addInt16(deviceID.length).
   addBytes(deviceID);
  }
  if(sessionID) {
   pb.addInt16(4).
   addInt16(sessionID.length).
   addBytes(sessionID);
  }
  if(permissioncode){
   pb.addInt16(257).
   addInt16(4).
   addInt32(permissioncode);
  } 
  sendpdu(pb);
 };
 
 this.sendData = function(connectionID, bytes) {
  var pb = new PB(TB);         
  pb.setHeader(getAckNumber(0),getSeqNumber(0),connectionID,32768).
  addBytes(bytes);
  sendpdu(pb);
 };
 
 this.closeVirtualConnection = function(connectionID) {
  var pb = new PB(TB);         
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,897).
  addInt16(256).
  addInt16(4).
  addInt32(connectionID);
  sendpdu(pb);
 };
 
 // Logout
 this.logout = function() {
  var pb = new PB(TB);      
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,5);
  sendpdu(pb);
 };
 
 this.getGroups = function() {
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,1664);
  sendpdu(pb);
 };
 
 //get a list of conversations queued for a group
 // bundle: {gid:,sort:,offset:,limit:}
 this.getListofConversationsQueuedOnGroup = function(groupID,sortOrder,offSet,limit) {
  if(isparbundle(groupID,sortOrder)) {
   var pars = groupID;
   groupID = any2bytes(pars.gid);
   sortOrder = any2bytes(pars.sort);
   offSet = any2bytes(pars.offset);
   limit = any2bytes(pars.limit);
  }
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,1666).
  addInt16(256).
  addInt16(groupID.length).
  addBytes(groupID);
  if(sortOrder) {
   pb.addInt16(258).
   addInt16(1).
   addByte(sortOrder);
  }
  if(offSet) {
   pb.addInt16(259).
   addInt16(4).
   addInt32(offSet);
  }
  if(limit) {
   pb.addInt16(260).
   addInt16(4).
   addInt32(limit);
  }
  sendpdu(pb);
 };

 // bundle: {gid:, convid:}
 this.selectQueuedConversation = function(groupID,conversationID) {
  if(isparbundle(groupID,conversationID)) {
   var pars = groupID;
   groupID = any2bytes(pars.gid);
   conversationID = any2bytes(pars.convid);
  }
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,1668)
   .addItem({tag:256,bytes:groupID})
   .addItem({tag:261,bytes:conversationID});
  sendpdu(pb);
 };
 // { convid:, gid: }
 this.enqueueConversation = function(p) {
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,1670);
  pb.addItem({tag:261,number:p.convid});
  if(p.gid) pb.addItem({tag:256,number:p.gid});
  sendpdu(pb);
  return this;
 };
 
 this.acceptVirtualConnection = function(connectionID,accept) {
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,899).
  addInt16(256).
  addInt16(4).
  addInt32(connectionID).
  addInt16(258).
  addInt16(1).
  addByte(accept);
  sendpdu(pb);
 };
 
 this.updateFileInfoRecord = function(fileInfoID, status) {
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,1025).
  addInt16(257).
  addInt16(fileInfoID.length).
  addBytes(fileInfoID).
  addInt16(576).
  addInt16(1).
  addByte(status);
  sendpdu(pb);
 };

 // bundle: { convid:, status: }
 this.changeSupportStatus = function(conversationID,statuscode) {
  if(isparbundle(conversationID,statuscode)) {
   var pars = conversationID;
   conversationID = any2bytes(pars.convid);
   statuscode = pars.status;
  }
  L.trace({cid:conversationID,status:statuscode},"changeSupportStatus");
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,395).
  addInt16(256).
  addInt16(conversationID.length).
  addBytes(conversationID).
  addInt16(271).
  addInt16(1).
  addByte(statuscode); // 0:pending ,1:open, 4:Interrupted, 5:Closed 
  sendpdu(pb);
 };
 this.profileUpdate = function(firstName,lastName,gender,language,phone,mobile,country,countryISO3,dob,email,IDA_code){
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,512);
  if(firstName){
   pb.addInt16(256).
   addInt16(firstName.length).
   addString(firstName);
  }
  if(lastName) {
   pb.addInt16(257).
   addInt16(lastName.length).
   addString(lastName);
  }
  if(phone) {
   pb.addInt16(260).
   addInt16(phone.length).
   addString(phone);
  }
  if(mobile) {
   pb.addInt16(264).
   addInt16(mobile.length).
   addString(mobile);
  }
  if(email) {
   pb.addInt16(263).
   addInt16(email.length).
   addString(email);
  }
  if(gender){
   pb.addInt16(258).
   addInt16(1).
   addByte(gender);
  }
  if(language){
   pb.addInt16(259).
   addInt16(8).
   addInt16(6);
   if(IDA_code){
     pb.addInt16(513).
     addInt16(2).
     addInt16(language);
   }
   else{
     pb.addInt16(512).
     addInt16(2).
     addString(language);
   }
  }
  if(country){
   if(IDA_code){
     pb.addInt16(261).
     addInt16(6).
     addInt16(515).
     addInt16(2).
     addInt16(country);
   }
   else{
     pb.addInt16(261).
     addInt16(13).
     addInt16(512).
     addInt16(2).
     addString(country).
     addInt16(513).
     addInt16(3).
     addString(countryISO3);
   }
  }
  if(dob){
   var dobBytes= [];
   dobBytes = tb.number2Bytes(dob);
   if(dobBytes){
   pb.addInt16(262).
   addInt16(dobBytes.length).
   addBytes(dobBytes.reverse());
   }
  }
  sendpdu(pb);
 };
 this.sendDiangosticResults = function(messageID,testID,evaluation,result,comments,timestamp,sessionID){
     var pb = new PB(TB);
     pb.setHeader(getAckNumber(0),getSeqNumber(0),0,1152).
     addInt16(256).
     addInt16(messageID.length).
     addBytes(messageID).
     addInt16(257).
     addInt16(testID.length).
     addBytes(testID).
     addInt16(260).
     addInt16(1).
     addByte(evaluation);
     if(result) {
       pb.addInt16(258).
       addInt16(result.length).
       addString(result);
     }
     if(comments) {
       pb.addInt16(259).
       addInt16(comments.length).
       addString(comments);
     }
    if(timestamp){
      var timestampBytes= [];
      timestampBytes = tb.number2Bytes(timestamp);
      if(timestampBytes){
      pb.addInt16(261).
      addInt16(timestampBytes.length).
      addBytes(timestampBytes.reverse());
     }
    }
    if(sessionID) {
      pb.addInt16(262).
      addInt16(sessionID.length).
      addBytes(sessionID);
     }
     sendpdu(pb);
  };
 
 this.pingServer = function(data) {
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),0,20);
  if(data) pb.addBytes(data);
  sendpdu(pb);
 };
 
 this.sendVCControlData = function(connectionID, info) {
  var pb = new PB(TB);
  pb.setHeader(getAckNumber(0),getSeqNumber(0),connectionID,34952).
  addString(info);
  sendpdu(pb);
 };
 // Callbacks
 var callbacks = {
  12: 'onCreateAccount', 4: 'onLogin', 1281: 'onLANID', 1283: 'onResolveLANID', 1284: 'onResolveLANIDOwner', 41: 'onDeviceRegister',
  27: 'onDeviceLogin', 129: 'onQueryPermissions', 65: 'onLookUp', 145: 'onGrantRequestPermission', 148: 'onQueryPendingPermissionsSets', 151: 'onPermissionStatus',
  385: 'onCreateConversation', 387: 'onMessage', 389: 'onTicketStatusChange', 391: 'onQueryListofConversationItems', 393: 'onQueryListofConversationMemberList', 900: 'onvirtualConnetionStatusChange',
  32768: 'onRemoteData', 32769: 'onSpeedTestData', 32770: 'onCircleLiveData', 1665: 'onQueryGroups', 1667: 'onQueryConversationsQueuedOnGroup', 898: 'onCreateVirtualConnection', 1026: 'onReceivingFileInfoData',
  515: 'onReceiveFileData', 1153: 'onDiagnosticResult', 1669: 'onConversationStatusChange', 21: 'onPingServer', 34952: 'onVCControlData',
  397: 'onAdminResult'
 };
 
 // Processes the data received from the server/peer (atm only server)
 var process = {
 
  // Response for "create user account"
  pdu12:function(pr) {
   var sessionKey = "";
   var status = pr.pl.di259.d; // if status == 0 success other wise failure
   if(pr.pl.di1) accountid = pr.pl.di1.d;
   if(pr.pl.di3) sessionid = pr.pl.di3.d;
   if(pr.pl.di260) sessionKey = tb.bytes2String(pr.pl.di260.d, 0, pr.pl.di260.l);
   var accountNameType = tb.getByte(pr.pl.di258.d);
   var accountName = tb.bytes2String(pr.pl.di258.d, 1, pr.pl.di258.l);
   _callback["onCreateAccount"](status, accountid, sessionid, accountNameType, accountName, sessionKey);
  },
  
  // Response for "user login"
  pdu4:function(pr) {
   var status = pr.pl.di256.d;
   var sessionKey="";
   if(pr.pl.di1) accountid = pr.pl.di1.d;
   if(pr.pl.di3) sessionid = tb.bytes2Number(pr.pl.di3.d);
   if(pr.pl.di260) sessionKey = tb.bytes2String(pr.pl.di260.d, 0, pr.pl.di260.l);
   var accountNameType = tb.getByte(pr.pl.di258.d);
   var accountName = tb.bytes2String(pr.pl.di258.d, 1, pr.pl.di258.l);
   //L.trace({status:status,acid:accountid,sid:sessionid,accountnametype:accountNameType,accountname:accountName},"Login response");
   _callback["onLogin"](status, accountid, sessionid, accountNameType, accountName,sessionKey);
  },
  
  // Response for "get LANID"
  pdu1281:function(pr) {
   if(pr.pl.di258) _callback["onLANID"](tb.bytes2String(pr.pl.di258.d, 0, pr.pl.di258.l));
   else _callback["onLANID"]("");
  },
  
  // Response for "resolve LANID"
  pdu1283:function(pr){
   if(pr.pl.di2) _callback["onResolveLANID"](tb.bytes2String(pr.pl.di2.d, 0, pr.pl.di2.l));
   else _callback["onResolveLANID"]("");
  },
  
  // Response for "resolve LANID" to the owner
  pdu1284:function(pr){
   if(pr.pl.di2) _callback["onResolveLANIDOwner"](tb.bytes2String(pr.pl.di2.d, 0, pr.pl.di2.l));
   else _callback["onResolveLANIDOwner"]("");
  },
  
  // Response for "register device"
  pdu41:function(pr) {
   var dn = tb.bytes2String(pr.pl.di256.d, 0, pr.pl.di256.l);
   var rcode = pr.pl.di257.d;
   var deviceid = pr.pl.di4.d;
   var token = pr.pl.di258.d;
   var model = "";
   var imei = "" ;
   var displayName = "";
   if(pr.pl.di259) model = pr.pl.di259.d;
   if(pr.pl.di261) imei = pr.pl.di261.d;
   if(pr.pl.di262) displayName = pr.pl.di262.d;
   _callback["onDeviceRegister"](deviceid,token,dn,rcode,model,imei,displayName);
  },
  
  // Response for "token login"
  pdu27:function(pr) {
   var s= pr.pl.di256.d;
   var deviceid = pr.pl.di4.d;
   var sessionKey="";
   var sessionid=0;
   var accountid;
   if(s==0) {
    if(pr.pl.di1) accountid = pr.pl.di1.d;
    if(pr.pl.di3) sessionid = tb.bytes2Number(pr.pl.di3.d);
    if(pr.pl.di260) sessionKey = tb.bytes2String(pr.pl.di260.d, 0, pr.pl.di260.l);
    token = pr.pl.di257.d;
    _callback["onDeviceLogin"](deviceid,token,sessionid,sessionKey,accountid);
   }
   else{
    _callback["onDeviceLogin"](deviceid,undefined,sessionid,sessionKey,accountid);
   }       
  },
  
  // Response for "query permissions"
  pdu129:function(pr) {
   var parray = null;
   var count = 0;
   var acid;
   var pc;
   if(pr.pl.di1) acid = pr.pl.di1.d;
   if(pr.pl.di256) pc = tb.getLittleEndianInt32(pr.pl.di256.d,0);
   if(pr.pl.di5) {
    count = tb.getLittleEndianInt32(pr.pl.di5.d,0);
   }
   if(pr.pl.di6) {
    var permissions = pr.pl.di6.d;
    var pb = new PB(TB);
    parray = pb.addBytes(permissions).extractarray();
    _permissions = _permissions.concat(parray);
   }
   if(count === _permissions.length) _callback["onQueryPermissions"](_permissions, pc, acid);
  },
  
  // Response for "lookup account"
  pdu65:function(pr) {
   var p = pr.pl;
   var pli = 0;
   var accountNameType = p[pli++];
   var anl = p[pli++];
   var accountName = tb.bytes2String(p,pli,anl);
   pli+= anl;
   accountid = tb.getBytes(p,pli,8);
   _callback["onLookUp"](accountNameType, accountName, accountid);
  },

  // Grant/Request permission - triggered from #144
  pdu145:function(pr) {
   var pID = pr.pl.di264.d;
   var acntID = pr.pl.di258.d; 
   _callback["onGrantRequestPermission"](acntID, pID);
  },
  
  // Pending permissions list
  pdu148:function(pr) {            
   var pb = new PB(TB);
   var npermissionSets = tb.getLittleEndianInt32(pr.pl.di5.d,0); //total number of permission sets
   var lpermissionSets = pb.addBytes(pr.pl.di6.d).extractarray(); // list of permission sets
   _callback["onQueryPendingPermissionsSets"](npermissionSets,lpermissionSets);           
  },
  
  // Permission status
  pdu151:function(pr) {
   var permissionID = pr.pl.di264.d;
   var statuscode = pr.pl.di266.d[0];
   var acid;
   var userdata;
   if(pr.pl.di128 && pr.pl.di128.d) {
    acid = pr.pl.di128.d.slice(0,8);
    userdata = pr.pl.di128.d.slice(8);
    _permission_info[String(permissionID)] = { acid: acid, userdata: userdata };
   }
   L.trace({pid:permissionID,status:statuscode},"PDU 151");
   var pi = _permission_info[String(permissionID)]||{};
   _callback["onPermissionStatus"](permissionID, statuscode, pi.acid, pi.userdata);
  },
  
  // Response for "create conversation" #384
  pdu385:function(pr) {
   var channelid = tb.getLittleEndianInt32(pr.pl.di260.d, 0); //permissionid/channelid
   var statuscode = pr.pl.di267.d;//0:Success (conversation created),1:Recycled (existing conversation returned),16:No permission      
   var accountid;
   var conversationid;
   if(pr.pl.di1) accountid = pr.pl.di1.d;
   if(pr.pl.di256) conversationid = pr.pl.di256.d;
   _callback["onCreateConversation"](channelid, statuscode, accountid, conversationid);
  },
  
  // Message received
  pdu387:function(pr) {
   var conversationID = pr.pl.di256.d;
   var accountID = pr.pl.di1.d;
   if(pr.pl.di2) var disName = tb.bytes2String(pr.pl.di2.d,0,pr.pl.di2.l); 
   var channelID = tb.getLittleEndianInt32(pr.pl.di260.d,0);
   var di = pr.pl.di261;
   var messageText = di?tb.bytes2String(di.d,0,di.l):"";
   var mseconds = tb.getLittleEndianInt32(pr.pl.di262.d,0);            
   var messageID = pr.pl.di263.d;
   if(pr.pl.di4) var deviceID = pr.pl.di4.d;
   L.trace("message received: " + messageText);
   var dont_confirm = _callback["onMessage"](conversationID, accountID, disName, messageText, mseconds,channelID,messageID,deviceID);
   if(!dont_confirm) that.confirmMessageDelivery(messageID);
  },
  
  // Conversation status change
  pdu389:function(pr) {
   var conversationID = pr.pl.di256.d;
   var statuscode = pr.pl.di268.d[0];
   var bundle = {
    convid: tb.bytes2Number(conversationID),
   };
   if(pr.pl.di1) bundle.acid=tb.bytes2Number(pr.pl.di1.d);
   if(pr.pl.di2) bundle.display_name = tb.bytes2String(pr.pl.di2.d,0,pr.pl.di2.l);
   if(pr.pl.di4) bundle.devid=tb.bytes2Number(pr.pl.di4.d);
   switch(statuscode) {
    case 1: // new user
    case 3: // new support member
     bundle.change='join';
     bundle.support = (statuscode==3);
     break;
    case 2: // user left
     bundle.change='leave';
     break;
    case 4: // status change
     bundle.change='status';
     bundle.status=pr.pl.di271.d[0];
     break;
    default:
     L.error({pr:pr,change:statuscode},"unknown change");
     break;
   }
   var convStatus;
   if(statuscode == 4) convStatus = pr.pl.di271.d[0];
   else convStatus = (pr.pl.di271 && pr.pl.di271.d)?pr.pl.di271.d[0]:0;
   L.trace(bundle,"pdu 389");
   _callback["onTicketStatusChange"](conversationID, convStatus, bundle);
  },
  
  // Conversations
  pdu391:function(pr) {
   var pb = new PB(TB);
   var nconversations = tb.getLittleEndianInt32(pr.pl.di5.d,0); //total number of conversations
   var lconversationItems = pb.addBytes(pr.pl.di6.d).extractarray(); // list of conversation items
   _callback["onQueryListofConversationItems"](nconversations,lconversationItems);            
  },
  
  // Conversation members
  pdu393:function(pr) {
   var pb = new PB(TB);
   var conversationID = (pr.pl.di256 && pr.pl.di256.d)?pr.pl.di256.d:0;            
   var nMembers = (pr.pl.di5 && pr.pl.di5.d)?tb.getLittleEndianInt32(pr.pl.di5.d,0):0; //total number of conversations
   var lMemberItems = (nMembers>0)?pb.addBytes(pr.pl.di6.d).extractarray():[]; // list of conversation items
   _callback["onQueryListofConversationMemberList"](conversationID,nMembers,lMemberItems);  
  },        
  
  pdu900:function(pr) {            
   var connectionID = tb.getLittleEndianInt32(pr.pl.di256.d,0);
   var statuscode = pr.pl.di259.d;
   var permissionCode = 0;
   if(statuscode==1) permissionCode = tb.getLittleEndianInt32(pr.pl.di257.d,0);
   _callback["onvirtualConnetionStatusChange"](connectionID,statuscode,permissionCode);
  },
  
  pdu32768:function(pr) {
   _callback["onRemoteData"](pr.pl);
  },
  
  pdu32769:function(pr) {
   _callback["onSpeedTestData"](pr.pl);
  },

  pdu32770:function(pr) {
   _callback["onCircleLiveData"](pr.pl);
  },

  pdu34952:function(pr) {
   _callback["onVCControlData"](pr.pl);
  },
  pdu1665:function(pr) {
   var parray = null;
   var count = 0;
   if(pr.pl.di5) {
    count = tb.getLittleEndianInt32(pr.pl.di5.d,0);
   }
   if(pr.pl.di6) {
    var groups = pr.pl.di6.d;
    var pb = new PB(TB);
    parray = pb.addBytes(groups).extractarray();
    _groups = _groups.concat(parray);
   }
   if(count === _groups.length)  _callback["onQueryGroups"](_groups);
  },
  
  pdu1667:function(pr) {
   var groupID = pr.pl.di256.d;
   var sortorder = pr.pl.di258.d;
   var offset = 0;
   var parray;
   if(pr.pl.di259) {
    offset = tb.getLittleEndianInt32(pr.pl.di259.d,0);
   }
   var limit = 0;
   if(pr.pl.di260) {
    limit = tb.getLittleEndianInt32(pr.pl.di260.d,0);
   }
   var count = 0;
   if(pr.pl.di5) {
    count = tb.getLittleEndianInt32(pr.pl.di5.d,0);
   }
   if(pr.pl.di6) {
    var conversations = pr.pl.di6.d;
    var pb = new PB(TB);
    parray = pb.addBytes(conversations).extractarray();
    _conversations = _conversations.concat(parray);
   }
   if(count === _conversations.length)
    _callback["onQueryConversationsQueuedOnGroup"](groupID,sortorder,offset,limit,_conversations);
   },
  pdu898:function(pr) {
    var connectionID = tb.getLittleEndianInt32(pr.pl.di256.d,0);
    var accountID = pr.pl.di1.d;
    var sessionID = pr.pl.di3.d;
    if(pr.pl.di257) var permissionCode = tb.getLittleEndianInt32(pr.pl.di257.d,0);
    _callback["onCreateVirtualConnection"](connectionID,accountID,sessionID,permissionCode);
   },
  pdu1026:function(pr) {
    var messageID = pr.pl.di256.d;
    var fileInfoID = pr.pl.di257.d;
    var filename = "", filepathname = "", filesize = 0, timestamp = 0, filetype = "";
    if(pr.pl.di512) filename = tb.bytes2String(pr.pl.di512.d,0,pr.pl.di512.l);
    if(pr.pl.di513) filepathname = tb.bytes2String(pr.pl.di513.d,0,pr.pl.di513.l);
    if(pr.pl.di514) filesize = tb.bytes2Number(pr.pl.di514.d, true);
    if(pr.pl.di515) timestamp = tb.getLittleEndianInt32(pr.pl.di515.d,0);
    if(pr.pl.di516) filetype = pr.pl.di516.d;
    _fileSize = filesize;
    _callback["onReceivingFileInfoData"](messageID,fileInfoID,filename,filepathname,filesize,timestamp,filetype);
   },
  pdu515:function(pr) {
    var fileInfoID = tb.getBytes(pr.pl,0,8);
    _fileData = _fileData.concat(tb.getBytes(pr.pl,8,pr.h.l-8));
    if(_fileSize === _fileData.length){
      _callback["onReceiveFileData"](_fileData,fileInfoID);
      _fileData = [];
    }
   },
  pdu1153:function(pr) {
   var messageID = pr.pl.di256.d;
   var testID = pr.pl.di257.d;
   var eCode = pr.pl.di260.d[0];
   var mseconds = 0;
   if(pr.pl.di261.d) mseconds = tb.getLittleEndianInt32(pr.pl.di261.d,0);
   var accountID = pr.pl.di1.d;
   var deviceID = 0;
   if(pr.pl.di4) deviceID = pr.pl.di4.d;
   var tResult = "", tComment = "", sessionID, resData="";
   if(pr.pl.di258) tResult = tb.bytes2String(pr.pl.di258.d,0,pr.pl.di258.l);
   if(pr.pl.di259) tComment = tb.bytes2String(pr.pl.di259.d,0,pr.pl.di259.l);
   if(pr.pl.di262) sessionID = pr.pl.di262.d;
   if(pr.pl.di266) resData = tb.bytes2String(pr.pl.di266.d,0,pr.pl.di266.l);
   var tidn = tb.bytes2Number(testID);
   if((tidn==121)||(tidn==122)) {
    if(eCode==2) _fileSize = +tResult;
   }
   _callback["onDiagnosticResult"](messageID,testID,eCode,mseconds,accountID,deviceID,tResult,tComment,sessionID,resData);
  },
  // Conversation status change
  pdu1669:function(pr) {
   var groupID = pr.pl.di256.d;
   var statuscode = pr.pl.di263.d;
   var conversationID = pr.pl.di261.d;
   _callback["onConversationStatusChange"](groupID, conversationID, statuscode);
  },
  pdu21:function(pr) {
   _callback["onPingServer"](pr.pl);
  },

  pdu397: function on_pdu_admin_result(pr) {
   _callback.onAdminResult({
    convid: tb.bytes2Number(pr.pl.di256.d),
    rc: pr.pl.di274.d[0]
   });
  }
 };
 // socket.io will callback here with status/data packets
 var bytesold = null;
 var callback = {
  status:function(data) {
   // once connected, sends a greeting packet to the server
   // and updates the app that it is connected
   if(data == "connected") {
   sendGreeting(_domain,_productid);
   _callback["connected"]();
   }
  },
  
  data:function(buffer) {
   // socket.io forwards all data here
   //L.trace("bytes received: " + buffer.length);

   var bytes = new Array();
   if(bytesold) bytes = bytes.concat(bytesold);
   bytes = bytes.concat(buffer);

   while(bytes.length) {
    // and the data is processed using the process call
    var pb = new PB(TB);
    var pr = pb.addBytes(bytes).extractpacket();
    if(pr) bytesold=null;
    else {
     bytesold = bytes;
     break;
    }

    //L.trace({pr:pr,bytes:bytes},"pdu received (raw)");
    ackNumber[0] = pr.h.sn;
    if(callbacks[+pr.h.pt] && _callback[callbacks[+pr.h.pt]] && process["pdu"+pr.h.pt]) process["pdu"+pr.h.pt](pr);
    else L.warn({pdu:pr.h.pt},"process - pdu"+pr.h.pt+" not found or not registered !");

    bytes = tb.getBytes(bytes,12+pr.h.l,bytes.length-12-pr.h.l);
    if(!bytes) bytes = new Array();
   }
  }
 };
}

if(typeof module !== 'undefined' && typeof module.exports !== 'undefined') module.exports = apilayer;
else window.apilayer = apilayer;
})();
/* vim:set expandtab: */
